/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFeedbackGetCompletionFeedback } from "../../funcs/llmFeedbackGetCompletionFeedback.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.GetCompletionFeedbackRequest$inboundSchema,
};

export const tool$llmFeedbackGetCompletionFeedback: ToolDefinition<
  typeof args
> = {
  name: "llm-feedback-get-completion-feedback",
  description: `Retrieve feedback by completion ID

Retrieves the existing feedback rating and description for a specific chat completion.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFeedbackGetCompletionFeedback(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
